var THREE = require("three");
var OrbitControls = require("./orbitControls.js");

var Model3dViewer = function(targetDOM) {
	this.scene = new THREE.Scene();;
    this.renderer = new THREE.WebGLRenderer({antialias: true, alpha: true});
    this.camera = null;
    this.cameraControls = null;
    this.targetDOM = targetDOM;

    this.hemisphereLight = new THREE.HemisphereLight(0xaaaaaa, 0x444444);
    this.directionalLight = new THREE.DirectionalLight(0xffffff, 0.5);
    this.directionalLight.position.set(1, 1, 1);	
};

Model3dViewer.prototype.render3JSObject = function(threeJSObject) {console.log(threeJSObject)
	//scene background
    this.scene.background = new THREE.Color('gray');

    //camera
    this.camera = new THREE.PerspectiveCamera(75, this.targetDOM.width() / this.targetDOM.height(), 0.1, 1000);
    this.camera.position.set(5, 5, 5);

    //updated renderer
    this.renderer.setSize(this.targetDOM.width(), this.targetDOM.height());
    this.targetDOM.append(this.renderer.domElement);

    //add 3d model
     this.scene.add(threeJSObject);

    //add lights
    this.scene.add(this.hemisphereLight);
    this.scene.add(this.directionalLight);

    //orbit controls
    if(!this.cameraControls) {
        this.cameraControls = new OrbitControls(this.camera, this.renderer.domElement);
        this.cameraControls.target = threeJSObject.position;
        this.cameraControls.addEventListener('change', this.renderScene.bind(this));
    }

    this.renderScene();
};

Model3dViewer.prototype.renderScene = function() {
    this.renderer.render(this.scene, this.camera);
};

Model3dViewer.prototype.clean = function() {
    this.scene = null;
    this.camera = null;
    this.renderer = null;
    this.cameraControls = null;
    this.targetDOM = null;
    this.hemisphereLight = null;
    this.directionalLight = null;
};

module.exports = Model3dViewer;